import { render, staticRenderFns } from "./StatusAddContactTagAutomation.vue?vue&type=template&id=6fdf91b7&scoped=true&"
import script from "./StatusAddContactTagAutomation.vue?vue&type=script&lang=js&"
export * from "./StatusAddContactTagAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf91b7",
  null
  
)

export default component.exports